import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcPaginationComponent } from './fc-pagination.component';
import { SharedModule } from '@shared/shared.module';
import { FcPaginationDialogComponent } from './components/fc-pagination-dialog/fc-pagination-dialog.component';

@NgModule({
  declarations: [FcPaginationComponent, FcPaginationDialogComponent],
  imports: [CommonModule, SharedModule],
  exports: [FcPaginationComponent],
})
export class FcPaginationModule {}
